import { Resources } from 'constants/resources';

import { useGoBack } from 'hooks/useGoBack';
import { queryClient } from 'providers/queryClient';
import { DeleteDialog, DeleteDialogProps } from 'shared/mui/Dialogs';
import { Typography } from 'shared/mui/Typography';
import { TypographyBold } from 'shared/mui/Typography/TypographyBold';

export const MethodLogosDeleteDialog: React.FC<Omit<DeleteDialogProps, 'details' | 'title'>> = (
  props,
) => {
  const { goBack } = useGoBack();

  const onSuccess = async () => {
    await queryClient.invalidateQueries({ queryKey: [Resources.MethodLogos] });
    goBack();
  };

  return (
    <DeleteDialog
      {...props}
      details={
        <Typography>
          Логотип <TypographyBold fontSize={16} text={props.record?.name || ''} /> будет удален без
          возможности восстановления.
        </Typography>
      }
      onSuccess={onSuccess}
      title="Удаление логотипа"
    />
  );
};
